import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquareSliders = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 2V12C0 13.125 0.875 14 2 14H12C13.0938 14 14 13.125 14 12V2C14 0.90625 13.0938 0 12 0H2C0.875 0 0 0.90625 0 2ZM12 1C12.5312 1 13 1.46875 13 2V12C13 12.5625 12.5312 13 12 13H2C1.4375 13 1 12.5625 1 12V2C1 1.46875 1.4375 1 2 1H12ZM10 9.5C10 9.78125 10.2188 10 10.5 10H11.5C11.75 10 12 9.78125 12 9.5C12 9.25 11.75 9 11.5 9H10.5C10.2188 9 10 9.25 10 9.5ZM8 8V9H2.5C2.21875 9 2 9.25 2 9.5C2 9.78125 2.21875 10 2.5 10H8V11C8 11.2812 8.21875 11.5 8.5 11.5C8.75 11.5 9 11.2812 9 11V8C9 7.75 8.75 7.5 8.5 7.5C8.21875 7.5 8 7.75 8 8ZM6 4.5C6 4.78125 6.21875 5 6.5 5H11.5C11.75 5 12 4.78125 12 4.5C12 4.25 11.75 4 11.5 4H6.5C6.21875 4 6 4.25 6 4.5ZM4 3V4H2.5C2.21875 4 2 4.25 2 4.5C2 4.78125 2.21875 5 2.5 5H4V6C4 6.28125 4.21875 6.5 4.5 6.5C4.75 6.5 5 6.28125 5 6V3C5 2.75 4.75 2.5 4.5 2.5C4.21875 2.5 4 2.75 4 3Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgSquareSliders);
export { ForwardRef as ReactComponent };
